'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var waitForPeers = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ipfs, peersToWait, topic) {
    var checkPeers;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            checkPeers = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var peers, hasAllPeers;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return ipfs.pubsub.peers(topic);

                      case 2:
                        peers = _context.sent;
                        hasAllPeers = peersToWait.map(function (e) {
                          return peers.includes(e);
                        }).filter(function (e) {
                          return e === false;
                        }).length === 0;
                        return _context.abrupt("return", hasAllPeers);

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function checkPeers() {
                return _ref2.apply(this, arguments);
              };
            }();

            _context4.next = 3;
            return checkPeers();

          case 3:
            if (!_context4.sent) {
              _context4.next = 5;
              break;
            }

            return _context4.abrupt("return", Promise.resolve());

          case 5:
            return _context4.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve, reject) {
                var interval;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        interval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  _context2.prev = 0;
                                  _context2.next = 3;
                                  return checkPeers();

                                case 3:
                                  if (!_context2.sent) {
                                    _context2.next = 6;
                                    break;
                                  }

                                  clearInterval(interval);
                                  resolve();

                                case 6:
                                  _context2.next = 11;
                                  break;

                                case 8:
                                  _context2.prev = 8;
                                  _context2.t0 = _context2["catch"](0);
                                  reject(_context2.t0);

                                case 11:
                                case "end":
                                  return _context2.stop();
                              }
                            }
                          }, _callee2, null, [[0, 8]]);
                        })), 100);

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x4, _x5) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function waitForPeers(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = waitForPeers;